import { CustomButton } from "../../../../components/CustomButton/CustomButton";
import "./CallToAction.css";

export const CallToAction = () => {
    return (
        <div className="cta-container">
            <p>
                Want to build
                <br /> something
                <br /> <strong>great?</strong>
            </p>
            <div
                className="button"
                onClick={() =>
                    window.open("https://camerondigital.com/contact/", "_blank")
                }
            >
                <div className="">
                    <CustomButton
                        content={`Let's Connect`}
                        direction={"right"}
                        size={"18px"}
                        weight={"300"}
                        borderBottom
                        light
                    />
                </div>
            </div>
        </div>
    );
};
